import { useState, useEffect } from 'react';
import { useDispatch } from 'dva';
import dayjs from 'dayjs';
import { useLocation } from 'umi';
import { Box } from '@material-ui/core';
import ResultList from './components/result_list/ResultList';
import SearchGroup from './components/search_group/SearchGroup';

export default () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  // 获取会员等级列表
  useEffect(() => {
    dispatch({ type: 'memberManagement/getLevels' });
  }, [dispatch]);

  // 获取优惠券列表
  useEffect(() => {
    dispatch({
      type: 'cpList/getSearchCpList',
      payload: {
        values: {
          name: null,
          status: null,
          type: [],
        },
      },
    });
  }, [dispatch]);

  // 获取门店列表
  useEffect(() => {
    dispatch({
      type: 'memberManagement/getStoreList',
      payload: {
        values: {
          pageNum: 1,
          pageSize: 9999,
        },
      },
    });
  }, [dispatch]);
  // 获取公司列表
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getCompany',
      payload: {
        values: {
          pageNum: 1,
          pageSize: 9999,
        },
      },
    });
  }, [dispatch]);

  const [searchParam, setSearchParam] = useState({
    consumeEndTime: null,
    consumeStartTime: null,
    sendStartTime: dayjs().format('YYYY-MM-DD'),
    sendEndTime: dayjs().format('YYYY-MM-DD'),
    couponId: '',
    mobile: '',
    // cardCode: '',

    pageSize: 10,
    couponType: '',
    status: '',
    level: null,
    companies: null,
    stores: null,
    thirdId: '',
    source: '',
    pageNum: 1,
  });

  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_coupon_center_coupon_data_details',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      {/* <TitleML title='优惠券核销列表' fontSize="20px" /> */}
      {/* <div style={{ color: '#000', fontSize: '22px', marginBottom: '14px' }}>
        优惠券核销
      </div> */}
      <SearchGroup
        searchParam={searchParam}
        setSearchParam={setSearchParam}
        pathname={pathname}
      />
      <ResultList
        searchParam={searchParam}
        setSearchParam={setSearchParam}
        pathname={pathname}
      />
    </Box>
  );
};
